import { defineStore } from 'pinia';
import { getCards } from '@/services/api'

export const useCardsStore = defineStore('cards', {
    state: () => ({
        cards: null
    }),

    getters: {
        getCards: state => state.cards
    },

    actions: {
        setCards(list){
            this.cards = list
        },
        removeCard(id){
            this.cards = this.cards.filter(card => card.id !== id)
        },
        async fetchCards() {
            const list = await getCards()
            this.setCards(list || [])
        }
    }
})